var map = {
	"./FoodCategory": 2882,
	"./FoodCategory.jsx": 2882,
	"./foodCategory.css": 5001,
	"./img/bowls_category_new.png": 3353,
	"./img/food_image.png": 8370,
	"./img/logo_text.png": 7263,
	"./img/salad_category_new.png": 3105,
	"./img/smoothies_category_new.png": 873
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3259;